/**
 * Shared keys for agent connector ↔ flowSpec mapping
 */

export const ALL_MODEL_PARAM_KEYS = [
  'modelsAnthropicClaude',
  'modelsDeepSeek',
  'modelsGoogleGemini',
  'modelsOpenAI',
  'modelsAzureOpenAi',
  'modelsAmazonBedrock',
  'customModel'
] as const;

export type ModelParamSlotKey = (typeof ALL_MODEL_PARAM_KEYS)[number];

/** RAG-related param keys cleared when RAG is disabled */
export const RAG_PARAM_KEYS = [
  'embeddingProvider',
  'embeddingModelName',
  'vectorDimension',
  'projectId',
  'location',
  'endpoint',
  'publisher',
  'maxRetries',
  'waitForModel',
  'maxResults',
  'minScore',
  'vectorStoreProvider',
  'host',
  'port',
  'database',
  'tableName',
  'indexName',
  'uri',
  'label',
  'embeddingProperty',
  'textProperty'
] as const;
